// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BvYMUSHQ3VZhSV {
  overflow: visible;
}
.BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.Ig0VMqSXaVagiQ {
  width: 620px;
  margin-right: auto;
  margin-left: auto;
  transition: width 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.Ig0VMqSXaVagiQ {
    transition: none;
  }
}
.BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.Ig0VMqSXaVagiQ.udR7hhdNKnONkc {
  width: 1080px;
}
@media only screen and (min-width: 637px) and (max-width: 1095px) {
  .BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.Ig0VMqSXaVagiQ.udR7hhdNKnONkc {
    width: calc(100vw - var(--ds-space-200, 16px));
  }
}
@media only screen and (max-width: 636px) {
  .BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.Ig0VMqSXaVagiQ,
  .BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.Ig0VMqSXaVagiQ.udR7hhdNKnONkc {
    width: calc(100vw - var(--ds-space-200, 16px));
    margin-right: var(--ds-space-100, 8px);
    margin-left: var(--ds-space-100, 8px);
  }
}
.BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.gVKBv3Rn1WqlNF {
  width: 620px;
  margin-right: auto;
  margin-left: auto;
  transition: width 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.gVKBv3Rn1WqlNF {
    transition: none;
  }
}
.BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.gVKBv3Rn1WqlNF.udR7hhdNKnONkc {
  width: 1080px;
}
@media only screen and (min-width: 936px) and (max-width: 1095px) {
  .BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.gVKBv3Rn1WqlNF.udR7hhdNKnONkc {
    width: calc(100vw - var(--ds-space-200, 16px));
  }
}
@media only screen and (max-width: 935px) {
  .BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.gVKBv3Rn1WqlNF,
  .BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.gVKBv3Rn1WqlNF.udR7hhdNKnONkc {
    width: 620px;
  }
}
@media only screen and (max-width: 636px) {
  .BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.gVKBv3Rn1WqlNF,
  .BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z.gVKBv3Rn1WqlNF.udR7hhdNKnONkc {
    width: calc(100vw - var(--ds-space-200, 16px));
    margin-right: var(--ds-space-100, 8px);
    margin-left: var(--ds-space-100, 8px);
  }
}
@media only screen and (max-width: 600px) {
  .BvYMUSHQ3VZhSV.n2JiYx2TrpRj9Z {
    margin-top: var(--ds-space-400, 32px);
  }
}
@media only screen and (max-width: 750px) {
  .BvYMUSHQ3VZhSV > div {
    /* stylelint-disable-next-line declaration-no-important */
    margin: var(--ds-space-0, 0) !important;
  }
}
`, ""]);
// Exports
export var cardBackDialog = `BvYMUSHQ3VZhSV`;
export var cardBackRedesign = `n2JiYx2TrpRj9Z`;
export var fixed = `Ig0VMqSXaVagiQ`;
export var withPanel = `udR7hhdNKnONkc`;
export var resizable = `gVKBv3Rn1WqlNF`;
export default ___CSS_LOADER_EXPORT___;
